import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  Typography,
  Divider,
  Pagination,
  Skeleton,
  Result,
  Button,
  Tag
} from "antd";
import Profile from "../profile";
import sad from "../../utils/images/sad.svg";
import LeadContext from "../../contexts/leads";

const { Paragraph } = Typography;

function LeadCard({ questions, id }) {
  const [visible, setVisible] = useState(false);
  const [lead, setLead] = useState({});
  const [page, setPage] = useState("1");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [answers, setAnswers] = useState({ answer: [] });
  const [total_answers, setTotal_answers] = useState(null);
  const { supplyApi } = useContext(LeadContext);

  useEffect(() => {
    loadAnswers();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const loadAnswers = () => {
    setLoading(true);
    supplyApi
      .get(
        `leads/?page=${page}&per_page=16&district_id=${id}`
      )
      .then(response => {
        setAnswers({ answer: response.data.leads });
        setTotal_answers(response.data.total_count);
        setLoading(false);
      })
      .catch(err => {
        setError(true);
        setLoading(false);
      });
  };

  const showDrawer = () => {
    setVisible(() => true);
  };

  if (loading !== false) {
    return (
      <div>
        <Skeleton active rows={20} />
      </div>
    );
  }

  if (error) {
    return (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={() => (window.location.href = "/")}>
            Home
          </Button>
        }
      />
    );
  }

  return (
    <div style={{ marginTop: 20 }}>
      <Card
        title={"Leads"}
        extra={
          answers.answer.length > 0 && (
            <Pagination
              total={total_answers}
              simple
              defaultCurrent={Number(page)}
              pageSize={16}
              onChange={x => setPage(x.toString())}
            />
          )
        }
      >
        {answers.answer.length > 0 ? (
          answers.answer.map(lead => {
            return (
              <Card.Grid
                className="gridStyle"
                onClick={() => {
                  showDrawer();
                  setLead(lead);
                }}
              >
                <p style={{ fontWeight: 800, float: "left" }}>
                  {lead.answers.find(x => x.question === 10).content}
                </p>

                <span style={{ float: "right" }}>
                  {lead.answers.find(x => x.question === 29) ? (
                    <Tag color="volcano">
                      {lead.answers.find(x => x.question === 29).content}
                    </Tag>
                  ) : null}
                </span>

                <Divider />

                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Email: </span>
                  <Paragraph>
                    {lead.answers.find(x => x.question === 12).content}
                  </Paragraph>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Phone: </span>
                  <Paragraph>
                    {lead.answers.find(x => x.question === 11).content}
                  </Paragraph>
                </div>
              </Card.Grid>
            );
          })
        ) : (
          <span>
            No leads found
            <img
              src={sad}
              alt=""
              style={{ height: 20, width: 20, marginLeft: 8, marginTop: -4 }}
            />
          </span>
        )}
      </Card>

      <Profile
        visible={visible}
        setVisible={setVisible}
        question={questions.question}
        lead={lead}
      />
    </div>
  );
}

export default LeadCard;
